__turbopack_context__.v({
  "btn": "drfifq_btn",
  "link": "drfifq_link",
});
